/**
 * Calculate deposition rate
 * Formula: (wireFeedSpeed * 60) / wireDensity * (efficiency / 100)
 *
 * @param {number} wireFeedSpeed - Wire feed speed in inches per minute
 * @param {number} wireDensity - Wire density value from data
 * @param {number} efficiency - Efficiency percentage
 * @returns {number} Deposition rate in lbs/hour
 */
export function calculateDepositionRate(wireFeedSpeed, wireDensity, efficiency) {
  if (
    typeof wireFeedSpeed !== 'number' ||
    typeof wireDensity !== 'number' ||
    typeof efficiency !== 'number'
  ) {
    return 0;
  }

  if (wireFeedSpeed <= 0 || wireDensity <= 0 || efficiency <= 0) {
    return 0;
  }

  const rate = ((wireFeedSpeed * 60) / wireDensity) * (efficiency / 100);
  return Math.round((rate + Number.EPSILON) * 100) / 100;
}

/**
 * Validate calculator inputs
 * @param {string} weldProcess - Selected weld process
 * @param {number} wireDensity - Selected wire density
 * @param {number} efficiency - Selected efficiency
 * @param {number} wireFeedSpeed - Wire feed speed input
 * @returns {boolean} True if all inputs are valid
 */
export function validateInputs(weldProcess, wireDensity, efficiency, wireFeedSpeed) {
  return Boolean(
    weldProcess &&
      wireDensity &&
      typeof wireDensity === 'number' &&
      wireDensity > 0 &&
      efficiency &&
      typeof efficiency === 'number' &&
      efficiency > 0 &&
      wireFeedSpeed &&
      typeof wireFeedSpeed === 'number' &&
      wireFeedSpeed > 0
  );
}
